import {
    mapSceneMapLayersActivateMapLayer,
    mapSceneMapLayersDeactivateMapLayer,
    mapSceneMapLayersUpdateMapLayerConfiguration,
    mapSceneMapLayersUpdatePrefixData,
    MapSceneMapLayersActionTypes,
    mapSceneMapLayersUpdatePrefixV2Data,
} from '../actions/reducers/mapLayers';
import {MapLayer} from '../../../interfaces/MapLayer';
import {getType} from 'typesafe-actions';
import {PrefixFilterOptions} from '../../../interfaces/PrefixFilterOptions';
import {Reducer} from 'redux';

export interface LayersState {
    [key: string]: MapLayer;
}

export interface MapSceneMapLayersReducerState {
    layers: LayersState;
    prefixes: PrefixFilterOptions;
}

const initialState: MapSceneMapLayersReducerState = {
    layers: {},
    prefixes: {
        avg: [],
        travelTimeV2: [],
    },
};

const mapLayersReducer: Reducer<MapSceneMapLayersReducerState, MapSceneMapLayersActionTypes> = (
    state: MapSceneMapLayersReducerState = initialState,
    action: MapSceneMapLayersActionTypes,
): MapSceneMapLayersReducerState => {
    switch (action.type) {
        case getType(mapSceneMapLayersActivateMapLayer):
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [action.payload.mapLayer.id]: {
                        ...action.payload.mapLayer,
                        isActive: true,
                    },
                },
            };
        case getType(mapSceneMapLayersDeactivateMapLayer):
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [action.payload.mapLayer.id]: {
                        ...state.layers[action.payload.mapLayer.id],
                        isActive: false,
                    },
                },
            };
        case getType(mapSceneMapLayersUpdateMapLayerConfiguration):
            return {
                ...state,
                layers: action.payload.mapLayers,
            };
        case getType(mapSceneMapLayersUpdatePrefixData):
            return {
                ...state,
                prefixes: {
                    ...state.prefixes
                },
            };
        case getType(mapSceneMapLayersUpdatePrefixV2Data):
            if(action.payload.prefixType === 'avg') {
                return updatePrefixState(state, action.payload.prefixes, 'avg');
            } else if(action.payload.prefixType === 'travelTimeV2') {
                return updatePrefixState(state, action.payload.prefixes, 'travelTimeV2');
            }

            return state;
        default:
            return state;
    }
};

function updatePrefixState(state: MapSceneMapLayersReducerState, prefixes: string[], key: keyof PrefixFilterOptions): MapSceneMapLayersReducerState {
    return {
        ...state,
        prefixes: {
            ...state.prefixes,
            [key]: prefixes
                .map((prefix) => ({
                    value: prefix,
                    label: prefix,
                }))
                .sort((a, b) => (a.value > b.value ? 1 : -1)),
        },
    };
}

export default mapLayersReducer;
